import React, { useState, useEffect } from 'react'
import "./CustomAccordion.css"
import { HiChevronDoubleDown } from "react-icons/hi";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';



const CustomAccordion = (props) => {
    const { id, title, permissions, allAdded, openedOnEdit, operationType, roleIsDefault } = props;

    const dispatch = useDispatch();

    const states = useSelector((state) => state, shallowEqual);
    
    React.useEffect(() => {
        console.log(props)
    }, [])


    const handleAllCheck = (id) => {
        var permissionsCopy = [...states.allPermissions]
        permissionsCopy.map(item => {
            if (item.id === id) {
                if (item.allAdded === true) {
                    item.allAdded = false
                    item.permissions.map(permission => {
                        permission.addedToRole = false
                        return permission;
                    })
                } else {
                    item.allAdded = true
                    item.permissions.map(permission => {
                        permission.addedToRole = true
                        return permission;
                    })
                }
            }

            return item;
        })
        dispatch({
            type: "SET",
            key: "allPermissions",
            payload: permissionsCopy,
        });



    }
    const handleChange = (catId, id) => {
        var permissionsCopy = [...states.allPermissions]

        permissionsCopy.map(item => {
            item.permissions.map(permission => {
                if (permission.id === id) {
                    if (permission.addedToRole === true) {
                        permission.addedToRole = false
                        permissionsCopy.map(item => {
                            if (item.id === catId) {
                                item.allAdded = false
                            }
                        })
                    } else {
                        permission.addedToRole = true
                    }
                }
                return permission;
            })
        }



        );

        dispatch({
            type: "SET",
            key: "allPermissions",
            payload: permissionsCopy,
        });
    }

    return (
        <div class="card mb-2">
            <div class="card-header" id="" data-toggle="collapse" data-target={`#accordion${id}`} style={{ cursor: "pointer" }} >
                <section class="mb-0 mt-0">
                    <div className="d-flex justify-content-between">
                        <div role="menu" style={{ color: "#3b3f5c", fontSize: "20px", fontWeight: "bold", textTransform: "capitalize" }} class="custom-accordion-header" 
                        aria-expanded="false" aria-controls="defaultAccordionTwo">
                            {/* aria-expanded, card-header collapsed */}
                            {title}
                        </div>
                        <div class="icons" ><HiChevronDoubleDown /></div>
                    </div>

                </section>
            </div>
            <div id={`accordion${id}`} 
            // Collapse show
            class={openedOnEdit==true ? "collapse show" : "collapse"} aria-labelledby="..." data-parent="#toggleAccordion">
                <div class="card-body">

                    <div className="d-flex flex-wrap">
                        <span class="n-chk ">
                            <label class="new-control new-checkbox new-checkbox-rounded checkbox-dark">
                                <input disabled={roleIsDefault}  type="checkbox" checked={allAdded} onChange={() => handleAllCheck(id)} class="new-control-input" />
                                <span class="new-control-indicator"></span> <span style={{ color: "#3b3f5c", opacity: "1", fontWeight: "bold" }} className="">Tout</span>
                            </label>
                        </span>
                        {permissions && permissions.map((permission, index) =>
                            <span class="n-chk ">
                                <label class="new-control new-checkbox new-checkbox-rounded checkbox-dark">
                                    <input disabled={roleIsDefault} type="checkbox" checked={permission.addedToRole} onChange={() => handleChange(id, permission.id)} class="new-control-input" />
                                    <span class="new-control-indicator"></span> <span style={{ color: "#3b3f5c", opacity: "1", fontWeight: "bold" }} className="">{permission.description}</span>
                                </label>
                            </span>
                        )}
                    </div>

                </div>
            </div>
        </div>
    )
}

export default CustomAccordion